exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._32AkT7SC1Q5mZ7XjXgMVl9{display:-webkit-box;display:-ms-flexbox;display:flex}html[dir] ._32AkT7SC1Q5mZ7XjXgMVl9{padding:10px;border:solid 1px \"[theme:neutralLight, default:#eaeaea]\";margin-bottom:6px}.l1eYwsnlVwtuKMnsent-P{font-size:15px;font-weight:400;display:-webkit-box;display:-ms-flexbox;display:flex}html[dir] .l1eYwsnlVwtuKMnsent-P{padding-bottom:20px}._190Ygg05kOL4OSoYR8nkEj{width:100%}html[dir] ._190Ygg05kOL4OSoYR8nkEj{padding-top:20px}html[dir=ltr] ._190Ygg05kOL4OSoYR8nkEj{padding-left:15px}html[dir=rtl] ._190Ygg05kOL4OSoYR8nkEj{padding-right:15px}", ""]);

// exports
exports.locals = {
	"brandView": "_32AkT7SC1Q5mZ7XjXgMVl9",
	"brandName": "l1eYwsnlVwtuKMnsent-P",
	"details": "_190Ygg05kOL4OSoYR8nkEj"
};